<div *ngIf="control && (control.touched || control.dirty) && control.errors">
  <div *ngFor="let error of controlErrors" id="{{ fieldName }}-{{ error }}-error" class="invalid-field">
    {{ errorMessage(error) }}
  </div>
</div>
